import type { IconsCache } from '@app/services/IconsCache'

import { createThunk } from '@app/store/thunk'

export function getIconsCache() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<IconsCache>(IconsCacheSymbol))
}
export function setIconsCache(value: IconsCache) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(IconsCacheSymbol, value))
}

const IconsCacheSymbol = Symbol('IconsCache')
